import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { SessionStorage } from 'ngx-webstorage';

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  @SessionStorage('auth') public user;
  public name: string;

  constructor(
    private router: Router,
    private snackBar: MatSnackBar) {
  }

  ngOnInit() {
    this.name = (this.user && this.user.userDetails) ? this.user.userDetails.name : '';
    if (this.user && this.user.userDetails && this.user.userDetails.userid === '') {
      this.router.navigate(['']);
    }
  }

  logout() {
    this.snackBar.open('Logged out successfully', 'okay', { duration: 2000, verticalPosition: 'top', horizontalPosition: 'center' });
    this.router.navigate(['']);
  }
}
